/**
 * @desc 导入箱子绑定Dono信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/importSupplierBoxBindDono`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
